var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWifi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256.22 191.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.22,61.1c-.39,7.56-2.8,11.66-7.82,14s-10.27,1-14.68-3c-7.15-6.47-14-13.44-21.76-19C153.78,11.11,74.64,18.31,24.56,69.72a24.2,24.2,0,0,1-7.91,5.78c-5.35,2.1-11.31-.34-14.43-5-3.37-5.08-2.93-11.2,1.53-16.06a167,167,0,0,1,47.52-36c66.46-33.9,148-20,199.22,34.06C253.21,55.33,254.94,59.13,256.22,61.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.18,97.3c-1,6-3.81,10.59-8.61,12.56a12.66,12.66,0,0,1-14.33-2.56c-4.4-4.06-8.46-8.54-13.17-12.21a94.36,94.36,0,0,0-126.62,9.4,23.25,23.25,0,0,1-8.83,6c-5.36,1.81-10.87-.9-13.75-5.58-3.08-5-2.6-10.85,1.67-15.68a117.51,117.51,0,0,1,37.26-28c47-22.8,104.47-12.19,139.84,26C218.32,90.1,220,93.91,222.18,97.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.3,98.47c21.43.4,39.33,8.56,53.54,24.66,6,6.75,5.8,14.84-.18,19.85-5.82,4.88-13.38,3.73-19.28-2.93-18.8-21.23-49.93-21.1-68.88.27-4.86,5.48-10.31,7-16,4.54-5.41-2.38-8.68-7.89-7.34-13.81a19.37,19.37,0,0,1,4.39-8.15C88.79,106.8,106.77,98.77,128.3,98.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.93,147.72a21.85,21.85,0,1,1-21.75,22.08A22,22,0,0,1,127.93,147.72Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.d9c92f3b5b10d6cff57b7c42b67e877c.svg";
export { ForwardRef as ReactComponent };